import * as $ from 'jquery';

function initCTATaskCardController() {

  if ($(".cta-container__task-card").length > 0) {

    $('.cta-container__task-card-content').on('show.bs.collapse', function () {
      $(this).closest(".cta-container__task-card").addClass("cta-container__task-card--open");
    });

    $('.cta-container__task-card-content').on('hidden.bs.collapse', function () {
      $(this).closest(".cta-container__task-card").removeClass("cta-container__task-card--open");
    });
  }

  if ($(".featured-faq__show-more").length > 0) {
    $(document).on('click', ".featured-faq__show-more", (function(e) {
      e.preventDefault();
      return ShowQuestionsWithinFaqSection(e.target);
    }));
  }

  let hash = window.location.hash;
  // When has hash
  if(hash !== undefined) {
      // replace react routing (could be automatically added depending on other widgets)
      if(hash.indexOf("#/") != -1) {
        hash = hash.replace("#/", "#");
      }
      // check if its not a react route (#/mijn-fnv/lid)
      // And there exists an element with the given id
      if(hash != "" && hash != "#" && hash.indexOf("/") == -1 && $(hash).length > 0) {
        // Get the section the element is in, if any
        let section = $(hash).closest('.faq-section');
        if(section) {
          // Get the show more button and trigger it, if any.
          let showMoreButton = section.find('.featured-faq__show-more');
          if(showMoreButton) {
            ShowQuestionsWithinFaqSection(showMoreButton);
          }
        }
      }
    }
}

function ShowQuestionsWithinFaqSection(showMoreElement)
{
  if(showMoreElement === undefined)
  {
    return false;
  }

  $(showMoreElement).parent().find(".featured-faq__hidden").removeClass("featured-faq__hidden");
  $(showMoreElement).remove();
  return false;
}

export { initCTATaskCardController };